import type { FC } from 'react'
import React from 'react'
import { Typography, useTheme } from '@mui/material'
import useFavurTranslation from 'hooks/useFavurTranslation'
import { AlertTriangleIcon } from 'redesign/components/atoms/Icon'
import { ICON_SIZE } from 'redesign/components/atoms/Icon/constants'
import HeaderBlock from 'redesign/components/molecules/HeaderBlock'
import routes from 'services/RoutesProvider/routes'
import Card from '../../../organisms/Card'
import { AlertContent, StyledAlert } from './styles'
import type { EventRestrictingAlertProps } from './types'
import { getEventAlertTitle } from './utils'

const EventRestrictingAlert: FC<EventRestrictingAlertProps> = ({ event }) => {
  const { t, locale } = useFavurTranslation()
  const { uuid } = event
  const { palette } = useTheme()

  // TODO: Improve design once final alert design is done
  return (
    <Card key={uuid} url={`${routes.cmsContentView}/${uuid}`}>
      <StyledAlert severity="warning" icon={false}>
        <AlertContent>
          <HeaderBlock
            icon={<AlertTriangleIcon size={ICON_SIZE.extraSmall} color={palette.warning.selected} />}
            title={getEventAlertTitle({ event, t, locale })}
            showChevron
          />
          <Typography variant="body2" color="text.secondary">
            {t('absenceRequest.new.absenceBlockerAlert.text')}
          </Typography>
        </AlertContent>
      </StyledAlert>
    </Card>
  )
}

export default EventRestrictingAlert
